import { Select, Button, Row, Col, Input } from "antd";
import React, { Component } from "react";

export default class DiaChi extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuong: this.props.listDuong,

      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuong: undefined,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }

    if (prevProps.listDuong !== this.props.listDuong) {
      this.setState({ listDuong: this.props.listDuong });
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == value);

    this.setState({
      selectedQuan: value,
      selectedPhuong: undefined,
      listPhuong: listPhuong,
    });
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == option.IDQuan);
    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN == option.IDQuan
    );
    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong: value,
      listPhuong: listPhuong,
    });
  }

  onChangeDuong(value) {
    this.setState({
      selectedDuong: value,
    });
  }

  onResetButton() {
    this.setState({
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuong: this.props.listDuong,

      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuong: undefined,

      SoNha: undefined,
      Kiet: undefined,
      Hem: undefined,
    });
  }

  onSearch = () => {
    let data = {
      selectedPhuong: this.state.selectedPhuong,
      selectedDuong: this.state.selectedDuong,
      SoNha: this.state.SoNha,
      Kiet: this.state.Kiet,
      Hem: this.state.Hem,
    };
    this.props.onSearch(data);
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div>
          <div className="group">
            <div className="gr-title-5">
              {/* <div className="required">*</div> */}
              <div className="text">Quận/Huyện</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                value={this.state.selectedQuan}
                onChange={(value) => this.onChangeQuan(value)}
                optionFilterProp = "name"
              >
                {this.state.listQuan.map((e, i) => (
                  <Select.Option value={e.MAHUYEN} key={i} name = {e.TENHUYEN}>
                    {e.TENHUYEN}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="group">
            <div className="gr-title-5">
              {/* <div className="required">*</div> */}
              <div className="text">Phường/Xã</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                onChange={(value, option) => this.onChangePhuong(value, option)}
                value={this.state.selectedPhuong}
                optionFilterProp = "name"
              >
                {this.state.listPhuong.map((e, i) => (
                  <Select.Option value={e.MaPhuong} IDQuan={e.MaQuan} key={i} name = {e.TenPhuong}>
                    {e.TenPhuong}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="group">
            <div className="gr-title-5">
              <div className="required">*</div>
              <div className="text">Đường</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                onChange={(value, option) => this.onChangeDuong(value, option)}
                value={this.state.selectedDuong}
                notFoundContent="Chức năng tìm kiếm theo tên đường chưa được phát triển ở giai đoạn này"
                optionFilterProp = "name"
              >
                {this.state.listDuong.map((e, i) => (
                  <Select.Option
                    value={e.OBJECTID}
                    IDPhuong={e.IDPhuong}
                    key={i}
                    name = {e.TenPhuong}
                  >
                    {e.TenDuong}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <Row gutter={[10, 0]}>
            <Col span={8}>
              <div className="group">
                <div className="gr-title-5">
                  <div className="required">*</div>
                  <div className="text">Số nhà</div>
                </div>

                <div className="gr-body">
                  <Input
                    className="input"
                    value={this.state.SoNha}
                    onChange={(e) => {
                      this.setState({ SoNha: e.target.value });
                    }}
                  ></Input>
                </div>
              </div>
            </Col>

            <Col span={8}>
              <div className="group">
                <div className="gr-title-5">
                  {/* <div className="required">*</div> */}
                  <div className="text">Kiệt</div>
                </div>

                <div className="gr-body">
                  <Input
                    className="input"
                    value={this.state.Kiet}
                    onChange={(e) => {
                      this.setState({ Kiet: e.target.value });
                    }}
                  ></Input>
                </div>
              </div>
            </Col>

            <Col span={8}>
              <div className="group">
                <div className="gr-title-5">
                  {/* <div className="required">*</div> */}
                  <div className="text">Hẻm</div>
                </div>

                <div className="gr-body">
                  <Input
                    className="input"
                    value={this.state.Hem}
                    onChange={(e) => {
                      this.setState({ Hem: e.target.value });
                    }}
                  ></Input>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              this.onResetButton();
            }}
          >
            Tìm mới
          </Button>
          <Button
            type="primary"
            className="button"
            onClick={this.onSearch}
            disabled={
              // this.state.selectedQuan &&
              // this.state.selectedPhuong &&
              this.state.selectedDuong && this.state.SoNha ? false : true
            }
          >
            Tìm kiếm
          </Button>
        </div>
      </div>
    );
  }
}
